import Link from "next/link";
import { FeedbackWidget } from "@/components/feedback/feedback-widget";

export function Footer() {
  return (
    <footer className="border-t border-border bg-card mt-auto">
      <div className="container max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">
              О проекте
            </h3>
            <p className="text-sm text-foreground-secondary mb-4">
              Peek Product — платформа для запуска стартапов в русскоязычной экосистеме.
            </p>
            <div className="flex items-center gap-3">
              <Link
                href="https://t.me/peekproduct"
                className="text-foreground-secondary hover:text-primary transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                </svg>
              </Link>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">
              Навигация
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/"
                  className="text-sm text-foreground-secondary hover:text-foreground transition-colors"
                >
                  Главная
                </Link>
              </li>
              <li>
                <Link
                  href="/submit"
                  className="text-sm text-foreground-secondary hover:text-foreground transition-colors"
                >
                  Разместить продукт
                </Link>
              </li>
              <li>
                <Link
                  href="https://t.me/peekproduct"
                  className="text-sm text-foreground-secondary hover:text-foreground transition-colors"
                >
                  Сообщество
                </Link>
              </li>
              <li>
                <Link
                  href="/about"
                  className="text-sm text-foreground-secondary hover:text-foreground transition-colors"
                >
                  О проекте
                </Link>
              </li>
              <li>
                <FeedbackWidget />
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">
              Ресурсы
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/help"
                  className="text-sm text-foreground-secondary hover:text-foreground transition-colors"
                >
                  Помощь
                </Link>
              </li>
              <li>
                <Link
                  href="https://boosty.to/peekproduct"
                  className="text-sm text-foreground-secondary hover:text-foreground transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Поддержать проект
                </Link>
              </li>
              <li>
                <Link
                  href="/rules"
                  className="text-sm text-foreground-secondary hover:text-foreground transition-colors"
                >
                  Правила сообщества
                </Link>
              </li>
              <li>
                <Link
                  href="/privacy"
                  className="text-sm text-foreground-secondary hover:text-foreground transition-colors"
                >
                  Политика конфиденциальности
                </Link>
              </li>
              <li>
                <Link
                  href="/terms"
                  className="text-sm text-foreground-secondary hover:text-foreground transition-colors"
                >
                  Пользовательское соглашение
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-tertiary text-center md:text-left">
            © 2026 Peek Product. Все права защищены.
          </p>
          <p className="text-sm text-foreground-tertiary text-center md:text-right">
            Создано с любовью к русским стартапам
          </p>
        </div>
      </div>
    </footer>
  );
}
